﻿import { setCookie, getCookie } from '../utilities/CookieUtils'

const cookieName = 'leshuttle.countrymodal.dismissed'

export function setupCountryModal () {
  const countryModal = document.querySelector('[data-country-modal]')

  if (!countryModal) {
    return
  }

  const dismissed = getCookie(cookieName)

  if (!dismissed) {
    showModal(countryModal)
    const dismissButton = countryModal.querySelector('button')

    if (dismissButton) {
      dismissButton.addEventListener('click', () => {
        dismissModal(countryModal)
      })
    }

    const dismissHref = countryModal.querySelector('a')

    if (dismissHref) {
      dismissHref.addEventListener('click', () => {
        dismissModal(countryModal)
      })
    }
  }
}

function showModal (modal) {
  modal.classList.remove('hide')
}

function dismissModal (modal) {
  setCookie(cookieName, true)

  modal.classList.add('hide')
}
